import { create } from 'zustand'

export const useLineItemStore = create(set => ({
  deleteKey: key =>
    set(state => {
      // Get current
      const tempItemsObj = { ...state }
      // Remove key
      delete tempItemsObj[key]
      // Convert to Array and back to object to reindex object keys preserve deleteKey and duplicateKey functions
      const tempItemsArray = Object.values(tempItemsObj).filter(
        item => typeof item !== 'function'
      )
      const newItemsObj = {}
      Object.assign(newItemsObj, tempItemsArray, {
        deleteKey: tempItemsObj['deleteKey'],
        duplicateKey: tempItemsObj['duplicateKey']
      })
      // Update State
      return newItemsObj
    }, true),
  duplicateKey: key =>
    set(state => {
      // Get current
      const tempItemsObj = { ...state }
      // Get number of keys (includes deleteKey and duplicateKey so we will minus 2)
      const numOfKeys = Object.keys(tempItemsObj).length - 2
      tempItemsObj[numOfKeys] = state[key]

      // Update State
      return tempItemsObj
    }, true)
}))
